import React from "react";

function RestoreUpdates() {
  const handleRestore = () => {
    alert("System restore initiated!");
  };

  const handleUpdate = () => {
    alert("System update initiated!");
  };

  return (
    <div>
      {/* Header Section */}
      <div className="bg-blue-50 p-6 rounded-lg mb-6">
        <h2 className="text-lg font-bold text-blue-800 mb-2">Restore & Updates</h2>
        <p className="text-xs text-gray-600">
          Manage system restores and updates. Use the options below to perform a system restore or update your software.
        </p>
      </div>

      {/* Restore Section */}
      <div className="mb-8">
        <h3 className="text-lg font-semibold text-gray-800 mb-4">Restore System</h3>
        <div className="bg-[#fdfdfd] p-6 rounded-lg shadow-md">
          <p className="text-xs text-gray-700 mb-4">
            Restore your system to a previous state. This action will roll back any recent changes.
          </p>
          <button
            className="bg-red-500 hover:bg-red-600 text-white font-medium px-4 py-2 rounded-lg transition text-xs"
            onClick={handleRestore}
          >
            Initiate Restore
          </button>
        </div>
      </div>

      {/* Updates Section */}
      <div>
        <h3 className="text-lg font-semibold text-gray-800 mb-4">System Updates</h3>
        <div className="bg-[#fdfdfd] p-6 rounded-lg shadow-md">
          <p className="text-xs text-gray-700 mb-4">
            Check for and install the latest updates to keep your system running smoothly.
          </p>
          <button
            className="bg-blue-600 hover:bg-blue-700 text-white font-medium px-4 py-2 rounded-lg transition text-xs"
            onClick={handleUpdate}
          >
            Check for Updates
          </button>
        </div>
      </div>
    </div>
  );
}

export default RestoreUpdates;